var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldenBandcampSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa-brands:bandcamp",
    clipPath: "url(#clip0_502_5434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5996 0.375C6.17774 0.375 0.974609 5.57812 0.974609 12C0.974609 18.4219 6.17774 23.625 12.5996 23.625C19.0215 23.625 24.2246 18.4219 24.2246 12C24.2246 5.57812 19.0215 0.375 12.5996 0.375ZM14.859 15.6609H6.37461L10.3449 8.34375H18.8293L14.859 15.6609Z",
    fill: "#FFDCA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_5434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenBandcampSvg);
export default __webpack_public_path__ + "static/media/GoldenBandcampSvg.2718302ad4ad7b597827218227a6d234.svg";
export { ForwardRef as ReactComponent };